import { useEffect } from "react";
import useDocumentTitle from "../../utils/useDocumentTitle";

import styles from "./index.module.scss";

import { Redirect } from 'react-router-dom';
import FlashCoachLogo from "../../components/_Icons/FlashCoachLogo";
import TDCXLogo from "../../components/_Icons/TDCXLogo";
import maintenanceImg from "../../images/maintenance.png";
import { clearLocalStorage } from "../../utils/auth";

export function Maintenance(props) {
  useEffect(() => {
    clearLocalStorage();
  }, []);
  useDocumentTitle(props.title);

  if (process.env.REACT_APP_MAINTENANCE_MODE !== "true") {
    return <Redirect to="/" />;
  }

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.loginBlock}>
        <div className={styles.logo}>
          <FlashCoachLogo />
        </div>
        <div className={styles.loginContent}>
          <img
            src={maintenanceImg}
            alt="fireSpot"
            style={{ maxWidth: "200px" }}
          />
          <h3>Temporarily Down for Maintenance</h3>
          <p>
            We are performing scheduled maintenance. We should be back online
            shortly
          </p>
        </div>
      </div>
      <div className={styles.footer}>
        <div className={styles.logo}>
          <TDCXLogo width={100} />
        </div>
        <div className={styles.copyright}>
          Copyright © 2021 TDCX. All Rights Reserved.
        </div>
      </div>
    </div>
  );
}
